import { Instagram, Music2 } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { GoldDivider } from "@/components/GoldDivider";
import { MoonPhases } from "@/components/MoonPhases";
import { useLang } from "@/i18n";

const QUICK_LINKS = [
    { href: "/#inicio", key: "nav.inicio", testid: "footer-link-inicio" },
    { href: "/#servicios", key: "nav.servicios", testid: "footer-link-servicios" },
    { href: "/#productos", key: "nav.productos", testid: "footer-link-productos" },
    { href: "/#velas", key: "nav.velas", testid: "footer-link-velas-personalizadas" },
    { href: "/#nosotros", key: "nav.nosotros", testid: "footer-link-sobre-nosotros" },
    { href: "/#ubicacion", key: "nav.ubicacion", testid: "footer-link-ubicacion" },
    { href: "/#contacto", key: "nav.contacto", testid: "footer-link-contacto" },
];

export const Footer = () => {
    const { t } = useLang();

    return (
        <footer data-testid="site-footer" className="relative bg-ink-deep border-t border-gold/15 px-5 sm:px-8 pt-16 pb-28 md:pb-12">
            <div className="max-w-5xl mx-auto text-center">
                <MoonPhases size={11} className="justify-center mb-6" />
                <p className="font-display font-semibold gold-text text-2xl sm:text-3xl tracking-wide">
                    {BUSINESS.name}
                </p>
                <p className="text-sm text-cream/60 font-light mt-3">
                    {BUSINESS.address}
                </p>
                <a href={`tel:${BUSINESS.phoneTel}`} data-testid="footer-phone-link"
                    className="inline-block text-sm text-gold-soft hover:text-gold transition-colors duration-300 mt-1.5">
                    {BUSINESS.phoneDisplay}
                </a>
                <p className="text-[11px] text-sand font-light mt-2">
                    {t("footer.hoursTitle")}: {t("location.monFri")} 10:00 AM a 6:00 PM · {t("location.sat")} 10:00 AM a 2:00 PM · {t("location.sun")} {t("location.closed")}
                </p>

                <div className="flex items-center justify-center gap-4 mt-7">
                    <a href="https://www.instagram.com/eljardin_devenuz" target="_blank" rel="noopener noreferrer"
                        data-testid="footer-instagram-link" aria-label="Instagram de Yerberia Jardin D'Venuz"
                        className="w-10 h-10 rounded-full border border-gold/35 flex items-center justify-center text-gold-soft hover:text-gold hover:border-gold/60 hover:shadow-[0_0_16px_rgba(212,175,55,0.2)] transition-[color,border-color,box-shadow] duration-300">
                        <Instagram className="w-4 h-4" />
                    </a>
                    <a href="https://www.tiktok.com/@eljardindelossecretos" target="_blank" rel="noopener noreferrer"
                        data-testid="footer-tiktok-link" aria-label="TikTok de Yerberia Jardin D'Venuz"
                        className="w-10 h-10 rounded-full border border-gold/35 flex items-center justify-center text-gold-soft hover:text-gold hover:border-gold/60 hover:shadow-[0_0_16px_rgba(212,175,55,0.2)] transition-[color,border-color,box-shadow] duration-300">
                        <Music2 className="w-4 h-4" />
                    </a>
                </div>

                <GoldDivider className="my-9" />

                <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3" aria-label="Enlaces rápidos">
                    {QUICK_LINKS.map((l) => (
                        <a key={l.href} href={l.href} data-testid={l.testid}
                            className="font-accent text-[10px] tracking-[0.22em] uppercase text-cream/55 hover:text-gold transition-colors duration-300">
                            {t(l.key)}
                        </a>
                    ))}
                </nav>

                <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3 mt-5" aria-label="Legal">
                    <a href="/privacidad" data-testid="footer-privacy-link"
                        className="font-accent text-[10px] tracking-[0.22em] uppercase text-sand hover:text-gold transition-colors duration-300">
                        {t("footer.privacy")}
                    </a>
                    <a href="/terminos" data-testid="footer-terms-link"
                        className="font-accent text-[10px] tracking-[0.22em] uppercase text-sand hover:text-gold transition-colors duration-300">
                        {t("footer.terms")}
                    </a>
                </nav>

                <p className="text-[11px] text-sand/90 font-light leading-relaxed max-w-2xl mx-auto mt-10" data-testid="footer-disclaimer">
                    {t("footer.disclaimer")}
                </p>

                <p className="text-[11px] text-sand mt-6 font-light">
                    {t("footer.copyright")}
                </p>
            </div>
        </footer>
    );
};
